export const red = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    widgetBg: '#fff',
    btnBg: '#ED5252',
    btnColor: '#fff',
    btnHoverBg: '#F06C6C',
    btnHoverColor: '#fff',
    btnActiveBg: '#D54A4A',
    btnActiveColor: '#fff',
    btnShadow: '#ED52528C',
    btnIconColor: '#fff',
};

export const lime = {
    colorTitle: '#FFFFFF',
    colorText: 'rgba(255, 255, 255, .7)',
    widgetBg: '#0A0E20',
    btnBg: '#7DFF4B',
    btnColor: '#0A0E20',
    btnHoverBg: '#C4FFAF',
    btnHoverColor: '#fff',
    btnActiveBg: '#44F500',
    btnActiveColor: '#fff',
    btnShadow: '#8EED628C',
    btnIconColor: '#0A0E20',
};

export const blue = {
    colorTitle: '#303446',
    colorText: '#4D5163',
    widgetBg: '#fff', //?
    btnBg: '#3885C6',
    btnColor: '#fff',
    btnHoverBg: '#5595CA',
    btnHoverColor: '#fff',
    btnActiveBg: '#0C406A',
    btnActiveColor: '#fff',
    btnShadow: '#5D8EEF8C',
    btnIconColor: '#fff',
};
